import { fetchCoupons } from 'admin/actions/coupon';
import { toQueryParams } from 'admin/utils';
import { useEffect, useState } from 'react';

const removeEmptyValues = (obj) => {
  const removed = {};
  Object.keys(obj).forEach((k) => {
    if (obj[k] !== '' && obj[k] !== null && obj[k] !== undefined) {
      removed[k] = obj[k];
    }
  });
  return removed;
};

const useCoupons = (initQuery = {}) => {
  const [coupons, setCoupons] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, max_page: 1 });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});

  const getCoupons = async (query = {}) => {
    const { isValid, errors } = validateQuery(query);
    if (isValid) {
      setIsLoading(true);
      setError({});
      const removed = removeEmptyValues(query);
      return await fetchCoupons(toQueryParams(removed))
        .then((data) => {
          setCoupons(data);
          setPagination(data.pagination);
        })
        .catch((error) => {
          setError(error);
        })
        .finally(() => setIsLoading(false));
    }
  };

  const validateQuery = (queryObj) => {
    const errors = {};
    const requiredKeys = ['private_money_id'];
    const lackKeys = requiredKeys.filter((k) => !Object.keys(queryObj).includes(k));
    lackKeys.forEach((k) => (errors[k] = `${k} is required`));
    const isValid = Object.keys(errors) == 0;
    return { isValid, errors };
  };

  useEffect(() => {
    getCoupons(initQuery);
  }, []);

  return [isLoading, coupons, pagination, error, getCoupons];
};

export default useCoupons;
